<template src="../template/web_login.html"></template>

<script>
export default {
  name: 'liveLogin'
}
</script>

<style scoped>

</style>
